import React from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'

export default function WNumericField({data, onChange, tabActive}) {
  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <TextField
          id="outlined-adornment-amount"
          value={'Calculation value viewable in action history'}
          disabled
          type={'text'}
          label={data.name}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
